import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useCfxAuth } from "@/context/CfxAuthContext";

export default function CfxCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { ingestToken } = useCfxAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    const error = params.get("error");
    if (error) {
      navigate(`/?cfx_error=${encodeURIComponent(error)}`, { replace: true });
      return;
    }
    if (!token) {
      navigate("/", { replace: true });
      return;
    }
    ingestToken(token).then(() => {
      navigate("/?cfx_login=1", { replace: true });
    });
  }, [params, navigate, ingestToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-6">
      <div className="flex flex-col items-center gap-4 text-center">
        <img src="/logo.png?v=4" alt="" className="h-12 w-12 object-contain drop-shadow-[0_0_18px_rgba(var(--theme-accent-primary-rgb),0.45)] animate-pulse" />
        <div className="font-mono text-[11px] tracking-[0.4em] text-[var(--accent)] uppercase cursor-blink">
          &gt; AUTHENTICATING_CFX
        </div>
      </div>
    </div>
  );
}
